module.exports = __webpack_public_path__ + "img/txt.3535a44f.png";